import dayjs from "dayjs";

export const columnsData = () => {
  return [
    {
      title: "Part Name",
      dataIndex: "partName",
      key: "partName",
    },
    {
      title: "Part ID",
      dataIndex: "partId",
      key: "partId",
    },
    {
      title: "Date of Part Addition",
      dataIndex: "startTime",
      key: "startTime",
      align: "center",
      render: (_,record) => dayjs(record?.startTime).format("DD-MM-YYYY") + " - " + (record?.endTime ? dayjs(record?.startTime).format("DD-MM-YYYY") : "Till Today"),
    },
    // {
    //   title: "Date of Part Remove",
    //   dataIndex: "endTime",
    //   key: "endTime",
    //   align: "center",
    //   render: (_,record) => record?.endTime ? dayjs(record?.startTime).format("DD-MM-YYYY HH:mm") : "Not yet ",
    // },
    {
      title: " ",
      dataIndex: "notes",
      key: "notes",
      render: (_,record) => record?.notes || " - ",
    }
  ];
};
